goog.provide('el8.appchart.reportFeeds.main');
goog.provide('el8.appchart.reportFeeds.feeds');

goog.require('el8.appchart.dialog.reports');
goog.require('el8.appchart.reportFeeds.actions');
goog.require('el8.appchart.reportFeeds.contentRenderer');
goog.require('el8.appchart.reportFeeds.expandFn');
goog.require('el8.appchart.reportFeeds.renderer');
goog.require('el8.appshared.dialog.imagesZoom');
goog.require('el8.data.reportTypes');
goog.require('el8.ptdata.fetch');
goog.require('el8.ptdata.getOrderSet');
goog.require('el8.template.appchart.reportFeeds');
goog.require('el8.uiwidget.CollapsibleFeed');
goog.require('el8.uiwidget.NewActionsMenu');
goog.require('el8.util.consts');


/**
 * This file manages the report feeds, which are displayed as part of the reports dialog
 * but are referenced from several other parts of the app. It is primarily called to:
 *  A. set the initial list of report types/feeds on chart load
 *  B. add a new report type that shows up in the chart after chart load
 */
el8.appchart.reportFeeds.main = (function() {

    var reportTypeIds;
    var that = {};


    /**
     * Called once during chart load to setup the list of report feeds we already know about
     */
    that.init = function(_reportTypeIds) {
        reportTypeIds = _reportTypeIds;

        // we need the dialog added to the DOM, because we're going to reference its DOM elements below
        el8.appchart.dialog.reports._init(reportTypeIds);
        var dialogContainer = el8.appchart.dialog.reports.getDialogContainer();

        updateWriteSeeMenu();

        // Keep track of the listeditors in the report feeds to give us a handle
        el8.appchart.reportFeeds.listeditors = {};

        for (var i=0; i<reportTypeIds.length; i++) {
            var rTypeId = reportTypeIds[i];
            setupFeedForReportType(rTypeId);
        }

        setupGeneralListeners(dialogContainer);
    };

    /**
     * Allows initial-feeds to manually load the report index, rather than waiting until the feed is displayed to fetch it
     */
    that.loadReportIndex = function(rTypeId, index) {
        var rType = that.getReportTypeFromId(rTypeId);
        el8.appchart.reportFeeds.feeds[rType].loadIndex(index);
    };

    /**
     * Creates a new report feed for rTypeId (a document_sub_type) and adds it to the
     * write/see menu. The report dialog should have added the relevant tab before this gets called.
     * This happens if, e.g., we receive a letter receipt referencing a report type we don't know about yet
     */
    that.addReportFeedAfterPageLoad = function(rTypeId) {
        setupFeedForReportType(rTypeId);

        reportTypeIds.push(rTypeId);
        updateWriteSeeMenu();

        // NOTE: if we end up with any more of these places where we're manually triggering
        // an update in another module, switch to using a special event on el8.data.reportTypes
        // or some other observer-based solution
        el8.appchart.letters.selectAttachments.addReportTabAfterPageLoad(rTypeId);
    };

    /**
     * Returns the key equivalent to what would come down as report_type on a report:
     * it's a lowercase version of the server's internal name for each type
     */
    that.getReportTypeFromId = function(rTypeId) {
        return el8Globals.AVAILABLE_REPORT_TYPES[rTypeId].report_type_label.toLowerCase();
    };

    /** Which report types are displayed on this page? */
    that.getCurrentReportTypeIds = function() {
        return reportTypeIds;
    };


    function setupFeedForReportType(rTypeId) {
        var rType = that.getReportTypeFromId(rTypeId);
        var dialogContainer = el8.appchart.dialog.reports.getDialogContainer();

        var container = $('.type-'+rTypeId+'-report-feed', dialogContainer);
        var actionsMenu = new el8.uiwidget.NewActionsMenu({
            container: container,
            anchorTop: container,
            menuId: rType+'-report-feed-actions-menu',
            highlightClassList: ['el8FeedItemSelected', 'el8FeedItemNewSelected', 'el8ItemSelected'],
            width: 270
        });
        var twoColActionsMenu = new el8.uiwidget.NewActionsMenu({
            container: container,
            anchorTop: container,
            menuId: rType+'-report-feed-actions-two-column-menu',
            highlightClassList: ['el8FeedItemSelected', 'el8FeedItemNewSelected', 'el8ItemSelected'],
            width: 400,
            twoColumn: true
        });

        var clickTriggerMap = el8.appchart.reportFeeds.actions.genClickMap(rType, actionsMenu, twoColActionsMenu);

        // Initialize the report feed
        el8.appchart.reportFeeds.feeds[rType] = new el8.uiwidget.CollapsibleFeed({
            container: container,
            scrollContainer: $('.report-feed-section', dialogContainer),
            name: rType,
            urlIndex: el8Globals['PATIENT_PATH']+'report-feed-index/'+rTypeId+'/',
            emptyMsg: 'No items to be displayed',
            rendererFn: el8.appchart.reportFeeds.renderer,
            fetchFn: el8.ptdata.fetch,
            pageSize: el8.util.consts.REPORT_FEED_PAGESIZE,
            navMode: 'feed',
            moreTrigger: '#report-feed-'+rType+'-more-btn',
            skeletonFn: function(spec) {
                spec = spec || {};
                spec['buttonId'] = 'report-feed-'+rType+'-more-btn';
                return el8.template.appchart.reportFeeds.feed(spec);
            },
            contentRendererFn: el8.appchart.reportFeeds.contentRenderer,
            contentWrapperClass: 'overlayFeedItem',
            clickTriggerMap: clickTriggerMap,
            addlResetItemFn: function(item, divElt) {
                // Anytime rendered element is removed from DOM,
                // make sure the models are aligned and ready to re-fetch
                // images and grids
                if (el8.model.identify.isReport(item)) {
                    item.setNotesLoaded(false);
                    item.setImagesLoaded(false);
                    if (item.getReportType() === 'lab' && item.hasGrids()) {
                        item.setGridsRendered(false);
                    }
                } else if (el8.model.identify.isNote(item)) {
                    item.setImagesLoaded(false);
                }
            },
            addlCollapseItemFn: function(item, divElt) {
                $('.el8FeedItemSpacer', divElt).hide();
            },
            addlExpandItemFn: function(item, divElt) {
                $('.el8FeedItemSpacer', divElt).show();
                el8.appchart.reportFeeds.expandFn(item, divElt);
            },
            feedDateFn: function(item) { return item.getDocumentDate(); }
        }).init();

        // The default scrollToTop just brings us to the top of the feed container,
        // and we actually need to scroll 15px more upwards to display also the
        // refresh trigger that structurally shows up above the feed container
        el8.appchart.reportFeeds.feeds[rType]._feedRenderer.scrollToTop = function() {
            this._scrollContainer.scrollTo(this._container, {offset: -25});
        };

        // Add a sign off callbackFn on each of these feeds
        el8.appchart.reportFeeds.feeds[rType].signOffCallbackFn = function(item) {
            el8.appchart.dialog.reports.refreshItem(item);
            el8.appchart.mainFeeds.chart.update();
            el8.appchart.mainFeeds.reqAct.remove(item);
            el8.appchart.mainFeeds.outstanding.remove(item);
            // A legal report also has a second report set for ref panel rendering
            if (item.getReportType() === "legal") {
                el8.ptdata.legalReportSetRP.addOrUpdate(item);
            }

            // it is very stupid that this file knows anything about letters selectAttachments
            // TODO: fix this by making sign off trigger a notify event
            el8.appchart.letters.selectAttachments.ensureFeedRefresh(item.getReportType());
            el8.appchart.letters.selectAttachments.ensureFeedRefresh('popular');
        };
    }

    /**
     * These are setup once total, not for each report type
     */
    function setupGeneralListeners($container) {
        // Add ability to click to zoom in on images
        $container.on('click', 'img.zoomable',  function() {
            var fid = $(this).attr('_fid');
            if (fid) {
                var item = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
                el8.appshared.dialog.imagesZoom.show({
                    images: item.getFullSizeImages ? item.getFullSizeImages() : []
                });
            }
        });

        // Add as observer to reports
        el8.ptdata.reports.bind('all', function(eventName, arg, arg2, arg3) {

            if (eventName === EVENTS.MOVED) {
                // arg is updated item, arg2 is old type
                el8.appchart.reportFeeds.feeds[arg2].remove(arg.getId());
                el8.appchart.dialog.reports.refresh(arg.getReportType(), false);
                el8.appchart.dialog.reports.show({ feedName: arg.getReportType() });

            } else if (eventName === EVENTS.UPDATED) {
                var reportType = arg.getReportType();
                // DO NOT refresh patient form report items. Their rendering is handled by React,
                // and they already understand how to update themselves in response to
                // changes in the data. Trying to additionally refresh them from legacy code
                // will cause them to unmount and remount, obliterating their local state.
                if (reportType !== 'patientform') {
                    el8.appchart.reportFeeds.feeds[reportType].refreshItem(arg);
                }
            } else if (eventName === EVENTS.DELETED) {
                el8.appchart.reportFeeds.feeds[arg.getReportType()].remove(arg.getId());

            } else if (eventName === EVENTS.MERGED) {
                var updatedReport = arg;
                var removedReport = arg2;
                var doShowItem = Boolean(arg3);
                var async = !doShowItem;
                el8.appchart.dialog.reports.refresh(removedReport.getReportType(), async);
                if (removedReport.getReportType() !== updatedReport.getReportType()) {
                    el8.appchart.dialog.reports.ensureRefresh(updatedReport.getReportType());
                }
                if (doShowItem) {
                    el8.appchart.dialog.reports.show({ item: updatedReport });
                }
            } else {
                el8.appchart.dialog.reports.ensureRefresh(arg.getReportType());
            }

        });

        el8.ptdata.letters.bind(EVENTS.DELETED, function(letter) {
            if (letter && letter.getReferralOrderId()) {
                el8.appchart.reportFeeds.feeds['consultation'].remove(letter.getReferralOrderId());
            }
        });

        el8.ptdata.letterReceipts.bind(EVENTS.FILED, function(receipt) {
            if (!receipt) { return; }

            // attachments on letter receipts have been filed into the report feed
            var reportIds = receipt.getAttachments()
                    .filter(function(attachment) { return el8.model.idToModelClass(attachment.getEntityId()) === 'Report'; })
                    .map(function(attachment) { return attachment.getEntityId(); });
            // include the letter cover sheet too
            if (receipt.getFiledAsDocumentId()) { reportIds.push(receipt.getFiledAsDocumentId()); }

            // SWAT-3826 Fetch these reports in {batchSize} increments due to URL size
            // Simplest fix for the error behavior the user is seeing, but there are
            // other optimizations we can do in the future.
            var batchSize = 150;
            for (var i = 0; i < reportIds.length; i += batchSize) {
                el8.ptdata.fetch({ fetchIds: reportIds.slice(i, i+batchSize) });
            }
            el8.appchart.dialog.reports.ensureRefreshAllAffected(reportIds);

        });

        // make sure changes in orders update the report feed
        el8.util.consts.ORDER_TYPES.forEach(function(orderType) {
            var orderSet = el8.ptdata.getOrderSet(orderType);
            var rTypeId = el8Globals.AVAILABLE_REPORT_TYPES_BY_KEY[orderType] ?
                el8Globals.AVAILABLE_REPORT_TYPES_BY_KEY[orderType].id : null;

            /* The rule here is that we have a Report Type corresponding to Order Type
             * and the practice has that report tab, the order will show up in that tab
             * (e.g., Pulmonary -> Pulmonary). The default fallback is consultation.
             * We won't know whether the report tab was added after page load, so in general,
             * we will almost always refresh consults and we'll refresh the other tab if it's
             * relevant (almost because we enforce that the lab and imaging tabs must be around).
             *
             * We're relying on the realtime updates below to make sure that if Pulmonary tab
             * exists for the practice, it's on this tab. Otherwise, we might have an order showing
             * up nowhere, because the client thinks it should still be in Consults but the server
             * says it now lives in Pulmonary. */
            orderSet.bind('all', function() {
                if (rTypeId && _.contains(reportTypeIds, rTypeId)) {
                    el8.appchart.dialog.reports.ensureRefresh(orderType);
                }
                if (orderType !== 'lab' && orderType !== 'imaging') {
                    el8.appchart.dialog.reports.ensureRefresh('consultation');
                }
            });
        });

        var onNoteUpdate = function(eventName, note, oldSubType) {
            if (eventName === EVENTS.MOVED) {
                var oldTabName = el8.appchart.dialog.reports.getTabNameForSubType(oldSubType);
                var newTabName = el8.appchart.dialog.reports.getTabNameForSubType(note.getDocumentSubType());

                el8.appchart.reportFeeds.feeds[oldTabName].remove(note.getId());
                el8.appchart.dialog.reports.refresh(newTabName, false);
                el8.appchart.dialog.reports.show({ feedName: newTabName });

            } else if (note && note.getDocumentSubType()) {
                var rType = el8.appchart.dialog.reports.getTabNameForSubType(note.getDocumentSubType());
                el8.appchart.dialog.reports.ensureRefresh(rType);
            }
        };
        el8.ptdata.visitNotes.bind('all', onNoteUpdate);
        el8.ptdata.nonvisitNotes.bind('all', onNoteUpdate);

        var reportTypeAddedListener = function(reportTypeObj) {
            var rTypeKey = reportTypeObj.getClientReportTypeKey();
            el8.appchart.dialog.reports.ensureRefresh(rTypeKey); // will also make sure this feed exists

            // if our new report type is also an order type, existing orders will jump
            // to it from the consult section, so we'll want to refresh the consult view
            if (_.contains(el8.util.consts.ORDER_TYPES, rTypeKey)) {
                el8.appchart.dialog.reports.ensureRefresh('consultation');
            }
        };
        var reportTypeDeletedListener = function(reportTypeObj) {
            var rTypeKey = reportTypeObj.getClientReportTypeKey();

            // if this isn't an order type, we don't need to take any actions:
            // reports won't move even if the report type is deleted
            if (!_.contains(el8.util.consts.ORDER_TYPES, rTypeKey)) { return; }

            // if it is a report type, make sure the reports jump back from our feed to consults
            el8.appchart.dialog.reports.ensureRefresh(rTypeKey);
            el8.appchart.dialog.reports.ensureRefresh('consultation');
        };
        // We're not currently planning to worry about reordering tabs on an existing chart:
        // we just want to make sure new tabs become visible so that data doesn't become hidden
        // and that orders end up in the correct feeds
        el8.data.reportTypes.bind(EVENTS.UPDATED, reportTypeAddedListener);
        el8.data.reportTypes.bind(EVENTS.CREATED, reportTypeAddedListener);
        el8.data.reportTypes.bind(EVENTS.DELETED, reportTypeDeletedListener);
    }

    /**
     * The write/see bar will have one item in its report dropdown per report type
     */
    function updateWriteSeeMenu() {
        var writeSeeData = reportTypeIds.map(function(typeId) {
            return el8Globals.AVAILABLE_REPORT_TYPES[typeId];
        });
        $('#report-type-write-see-menu').html(
            el8.template.appchart.reportFeeds.writeSeeMenu({
                reportTypes: writeSeeData
            })
        );
    }


    return that;


})();
